import httpRequest from './httpRequest'

export type AgeStatus = {
  enabled: boolean
  runtimeEnabled: boolean
  declared: boolean
  ageGroup: 'unknown' | 'adult' | 'minor_14_17' | 'minor_under_14'
  guardianPhoneMasked: string
  serviceConsentGranted: boolean
  accessAllowed: boolean
  accessReason: string
}
export type GuardianConsent = { requestCode: string; status: string; guardianRequestEmail: string }

export const getAgeStatus = () => httpRequest.get<AgeStatus>('/v1/miniprogram/age-profile/status')
export const submitAgeProfile = (birthDate: string, guardianPhone: string) =>
  httpRequest.post<AgeStatus>('/v1/miniprogram/age-profile/submit', { birthDate, guardianPhone })
export const getGuardianConsent = () => httpRequest.get<GuardianConsent>('/v1/miniprogram/guardian-service-consent')
export const createGuardianConsent = () => httpRequest.post<GuardianConsent>('/v1/miniprogram/guardian-service-consent')
